import React from 'react';
import Modal from './Modal';

const DriverInfoModal = ({ isOpen, onClose, driver }) => {
  if (!driver) return null;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div className="sm:flex sm:items-start">
          <div className="mt-3 text-center sm:mt-0 sm:text-left w-full">
            <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">
              Sürücü Bilgileri
            </h3>

            <div className="bg-gray-50 rounded-lg p-4 mb-4">
              <h4 className="text-sm font-medium text-gray-700 mb-2">
                Kişisel Bilgiler
              </h4>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Ad</p>
                  <p className="text-sm font-medium">
                    {driver.first_name} {driver.last_name}
                  </p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Telefon</p>
                  <p className="text-sm font-medium">{driver.phone_number}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">E-Posta</p>
                  <p className="text-sm font-medium">{driver.email}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Lisans Numarası</p>
                  <p className="text-sm font-medium">{driver.license_number}</p>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 rounded-lg p-4">
              <h4 className="text-sm font-medium text-gray-700 mb-2">
                Araç Bilgileri
              </h4>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-sm text-gray-500">Çekici Plaka</p>
                  <p className="text-sm font-medium">{driver.tow_plate}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Dorse Plaka</p>
                  <p className="text-sm font-medium">{driver.trailer_plate}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button
          type="button"
          className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
          onClick={onClose}
        >
          Kapat
        </button>
      </div>
    </Modal>
  );
};

export default DriverInfoModal;
